import {
  ADD_PAGE,
  ORDER_PAGES,
  REMOVE_PAGE,
  UPDATE_PAGE,
  SET_PAGES,
  SET_SELECTED_PAGE,
  UPDATE_ELEMENT
} from '../types'

const initialState = []

export const pages = function ( state = initialState, action ) {
  const { type, payload } = action
  switch( type ) {

  case SET_PAGES:
    return [ ...payload ]
    
  case ADD_PAGE:
    state.push( payload )
    return [ ...state ]

  case REMOVE_PAGE:
    return state.filter( i => +i.id !== +payload )
  
  case UPDATE_PAGE:
    const { pageItem } = payload
    return state.map( page => {
      if( +page.id === +pageItem.id ) {
        const newPage = { ...page, ...pageItem }
        return newPage
      }
      return page
    } )
  
  case ORDER_PAGES:
    const { dragData, dropData } = payload
    const sortedItems = state.map( page => {
      if( page.id === dragData.page_id ) {
        page.page_position = dropData.index
      } else if( page.id === dropData.page_id ) {
        page.page_position = dragData.index
      }
      return page
    } ).sort( ( a,b ) => a.page_position - b.page_position )
    return [ ...sortedItems ]

  case UPDATE_ELEMENT: 
    const { content, id, id_page } = payload
    const newState = state.map( page => {
      if( +page.id === +id_page ) {
        page.items.map( item => {
          if( +item.id === +id ) {
            item.content = JSON.stringify( content )
          }
          return item
        } )
      }
      return page
    } )
    return newState

  default:
    return state
  }
}

export const activePage = function ( state = null, action ) {
  const { type, payload } = action
  if( type === SET_SELECTED_PAGE ) {
    return { ...payload }
  }
  return state
}



// WEBPACK FOOTER //
// ./src/store/reducers/pages.js